export enum CalculationPeriodEnum {
  EndOfYear = 'END_OF_YEAR',
  SpecificPayCycle = 'SPECIFIC_PAY_CYCLE',
}